export default __webpack_public_path__ + "static/media/crowd.9ae1a89c.jpg";